var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portlet"},[_vm._t("title",[_vm._t("caption"),_vm._v(" "),_vm._t("actions")]),_vm._v(" "),(_vm.hasSlot('body'))?_c('div',{staticClass:"portlet-body"},[_vm._t("body")],2):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd892d4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/happypack/loader.js?id=eslint!./src/app/components/Portlet.vue
// module id = 443
// module chunks = 8